import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1Caption5Secondary extends ITextBoxProps {}

export const TextBoxMaxLine1Caption5Secondary = ({
  title,
  color = Colors.TEXT_ICON_SECONDARY,
  font = TextBoxTypes.Caption5,
  alignment = TextAligning.Left,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1Caption5Secondary): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
